import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import slugTransform from 'slug';

import Container from './global/container';
import Social from './social';

const FooterStyle = styled.div`
	footer {
		color: #fff;
		padding: 3rem 0;
		background-color: #373239;
	}

	a:hover {
		color: ${(p) => p.theme.color.blue};
	}

	.photos {
		display: flex;
		justify-content: center;
		align-items: center;
		@media all and (max-width: 768px) {
			display: none;
		}
		div {
			background-position: center;
			background-size: cover;
			background-repeat: no-repeat;
			height: 10rem;
			width: 100%;
			&:nth-child(1) {
				background-image: url(/img/footer-1.png);
			}
			&:nth-child(2) {
				background-image: url(/img/footer-2.jpg);
			}
			&:nth-child(3) {
				background-image: url(/img/footer-3.png);
			}
			&:nth-child(4) {
				background-image: url(/img/footer-4.png);
			}
			&:nth-child(5) {
				background-image: url(/img/footer-5.png);
			}
			&:nth-child(5) {
				background-image: url(/img/footer-5.png);
			}
			&:nth-child(6) {
				background-image: url(/img/footer-6.png);
			}
		}
	}

	.flex {
		display: flex;
		.logo-col {
			width: 30%;
			text-align: center;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			.logo-wrap img {
				margin: 0 auto;
				width: 150px;
			}
			p {
				margin-top: 1rem;
				font-weight: 700;
			}
		}
		.links {
			width: 70%;
			h3 {
				font-size: 1.3rem;
				line-height: 1.7rem;
				margin-bottom: 1rem;
			}

			.lists {
				display: flex;
				.locations {
					width: 60%;
					border-right: 2px solid #fff;
					padding-right: 1rem;
					padding-bottom: 1rem;
					.list {
						display: flex;
						flex-wrap: wrap;
						a {
							width: 33.3%;
							margin-bottom: 1rem;
							padding-right: 0.5rem;
							font-size: 0.8rem;
						}
					}
				}
				.lessons {
					width: 40%;
					padding-left: 2rem;
					.list {
						display: flex;
						flex-wrap: wrap;
						a {
							width: 50%;
							margin-bottom: 1rem;
							font-size: 0.8rem;
						}
					}
				}
			}
			ul {
				margin: 1rem 0 2rem;
				display: flex;
				li {
					padding-right: 2rem;
					padding-top: 1rem;
					&:last-child {
						padding-right: 0;
					}
				}
			}
		}
		@media all and (max-width: 1000px) {
			.links {
				.lists {
					flex-direction: column;
					.locations {
						width: 100%;
						border-right: none;
						border-bottom: 2px solid #fff;
						padding-right: 0;
						padding-bottom: 1rem;
					}
					.lessons {
						width: 100%;
						border-bottom: 2px solid #fff;
						padding: 2rem 0 1rem 0;
						.list a {
							width: 33.3%;
						}
					}
				}
				ul {
					flex-wrap: wrap;
					li {
						width: 33.3%;
					}
				}
			}
		}
		@media all and (max-width: 678px) {
			flex-direction: column;
			.logo-col {
				width: 100%;
				flex-direction: row;
				margin-bottom: 2rem;
				.logo-wrap,
				.phones {
					width: 50%;
				}
			}
			.links {
				width: 100%;
				.lists {
					flex-direction: row;
					border-bottom: 2px solid #fff;
					max-width: 400px;
					margin: 0 auto;
					.locations,
					.lessons {
						width: 50%;
						padding: 0 1rem 0 0;
						border-bottom: none;

						.list {
							display: none;
							a {
								width: 100%;
							}
						}
						&.isOpen {
							h3::after {
								transform: rotate(180deg);
							}
							.list {
								display: flex;
							}
						}
						h3 {
							position: relative;
							width: fit-content;
							&::after {
								content: url(/img/chevron-up.svg);
								transform: rotate(0deg);
								transition: 0.3s transform;
								width: 20px;
								height: 20px;
								position: absolute;
								top: 0;
								right: -1.75rem;
								@media screen and (-ms-high-contrast: active),
									(-ms-high-contrast: none) {
									right: 0rem;
								}
							}
						}
					}
					.lessons {
						padding-right: 0;
					}
				}

				ul {
					justify-content: center;
					max-width: 400px;
					margin: 1rem auto 2rem;
					li {
						width: 50%;
						padding: 1rem 1rem 0;
						text-align: center;
					}
				}

				.bottom {
					text-align: center;
					p {
						margin-top: 1rem;
					}
				}
			}
		}
	}
`;

export default () => {
	const [locationsOpen, setLocationsOpen] = useState(false);
	const [lessonsOpen, setLessonsOpen] = useState(false);

	return (
		<FooterStyle>
			<div className="photos">
				{[...Array(6)].map((_, i) => (
					<div key={i} />
				))}
			</div>
			<footer>
				<Container>
					<div className="flex">
						<div className="logo-col">
							<div className="logo-wrap">
								<Link to="/">
									<img src="/img/logo.png" alt="arcadia logo" />
								</Link>
							</div>
							<div className="phones">
								<p>INQUIRIES:</p>
								<a className="phone" href="tel:+18882388079">
									1-888-238-8079
								</a>
								<p>FRANCHISING:</p>
								<a className="phone" href="tel:+19058503701">
									905-850-3701
								</a>
							</div>
							<Social margin="1.5rem" center={true} className="show-mobile" />
						</div>
						<div className="links">
							<div className="lists">
								<div
									className={locationsOpen ? 'locations isOpen' : 'locations'}
								>
									<h3 onClick={() => setLocationsOpen(!locationsOpen)}>
										LOCATIONS
									</h3>
									<div className="list">
										{locations.map((x, i) => (
											<Link
												key={i}
												to={`/${slugTransform(x, { lower: true })}/`}
											>
												{x}
											</Link>
										))}
									</div>
								</div>
								<div className={lessonsOpen ? 'lessons isOpen' : 'lessons'}>
									<h3 onClick={() => setLessonsOpen(!lessonsOpen)}>LESSONS</h3>
									<div className="list">
										{lessons.map((x, i) => (
											<Link key={i} to={x.link}>
												{x.text}
											</Link>
										))}
									</div>
								</div>
							</div>
							<nav>
								<ul>
									<li>
										<Link to="/careers/">CAREERS</Link>
									</li>
									<li>
										<Link to="/franchising/">FRANCHISING</Link>
									</li>
									<li>
										<a href="/franchisee-toolkit/">TOOLKIT</a>
									</li>
									<li>
										<Link to="/privacy/">PRIVACY & TERMS</Link>
									</li>
								</ul>
							</nav>
							<div className="bottom">
								<Social margin="1.5rem" center={true} className="hide-mobile" />
								<p>
									&copy;{new Date().getFullYear()} Arcadia Academy of Music. All
									Rights Reserved.
								</p>
							</div>
						</div>
					</div>
				</Container>
			</footer>
		</FooterStyle>
	);
};

// This array is ordered Left to Right, not alphabetically
// but by doing this it displays alphabetically

const locations = [
	'BURLINGTON',
	'MAPLE',
	'NOBLETON',
	'BRAMPTON NORTH',
	'MARKHAM',
	'RICHMOND HILL',
	'BRAMPTON SOUTH',
	'NEWMARKET',
	'WOODBRIDGE',
	'BRAMPTON WEST',
];

const lessons = [
	{
		text: 'PIANO',
		link: '/piano/',
	},
	{
		text: 'GUITAR',
		link: '/guitar/',
	},
	{
		text: 'DRUMS',
		link: '/drums/',
	},
	{
		text: 'VOICE & THEORY',
		link: '/voice-and-theory/',
	},
	{
		text: 'STRINGS',
		link: '/strings/',
	},
	{
		text: 'BRASS & WOODWINDS',
		link: '/brass-and-woodwinds/',
	},
	{
		text: 'ARCADIA ROCKS',
		link: '/arcadia-rocks/',
	},
];
